/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:00f8bde8-95e9-44b1-bcf0-4d99bb096c18",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_zVXCWqcAp",
    "aws_user_pools_web_client_id": "3hgfjabb6u7seqkeih99is46sk",
    "oauth": {
        "domain": "testinvestwithaqua.auth.us-east-1.amazoncognito.com"
    },
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 10,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "aqua-api-staging-bucket",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
